import { render, staticRenderFns } from "./ObdTalkParam.vue?vue&type=template&id=03708de8&"
import script from "./ObdTalkParam.vue?vue&type=script&lang=js&"
export * from "./ObdTalkParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports